import { getCookie as r } from "./index78.mjs";
const a = (o = "ads_source") => {
  const e = r(o), t = new URLSearchParams(window.location.search);
  return e || t.get(o) || null;
};
export {
  a as getABoostValue
};
